import { Helmet } from "react-helmet";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { HeroSection } from "@/components/sections/HeroSection";
import { TopicSection } from "@/components/sections/TopicSection";
import { ConsultingSection } from "@/components/sections/ConsultingSection";
import { SupportAreasSection } from "@/components/sections/SupportAreasSection";
import { AiSection } from "@/components/sections/AiSection";
import { BusinessPlansSection } from "@/components/sections/BusinessPlansSection";
import { FaqSection } from "@/components/sections/FaqSection";
import { AiLinksSection } from "@/components/sections/AiLinksSection";
import { CompanyProfileSection } from "@/components/sections/CompanyProfileSection";
import { ContactSection } from "@/components/sections/ContactSection";
import { HomeFooter } from "@/components/sections/HomeFooter";

import { PrivacyPolicyModal } from "@/components/modals/PrivacyPolicyModal";
import { TermsOfServiceModal } from "@/components/modals/TermsOfServiceModal";
import { BackToTopButton } from "@/components/BackToTopButton";
import { useHomeMotion } from "@/hooks/useHomeMotion";

import "@/styles/home.css";

const Index = () => {
  const { t } = useTranslation();
  const [privacyPolicyOpen, setPrivacyPolicyOpen] = useState(false);
  const [termsOfServiceOpen, setTermsOfServiceOpen] = useState(false);

  useHomeMotion();

  return (
    <div className="home-page">
      <Helmet>
        <title>{t("index.page_title")}</title>
        <meta name="description" content={t("index.meta_description")} />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0" />
      </Helmet>

      {/* 読了進行線。useHomeMotion が --progress を入れる */}
      <div className="reading-progress" aria-hidden="true">
        <i />
      </div>

      <main>
        <HeroSection />
        <TopicSection />
        <ConsultingSection />
        <SupportAreasSection />
        <AiSection />
        <BusinessPlansSection />
        <FaqSection />
        <AiLinksSection />
        <CompanyProfileSection />
        <ContactSection />
      </main>

      <HomeFooter
        onOpenPrivacyPolicy={() => setPrivacyPolicyOpen(true)}
        onOpenTermsOfService={() => setTermsOfServiceOpen(true)}
      />

      <PrivacyPolicyModal open={privacyPolicyOpen} onOpenChange={setPrivacyPolicyOpen} />
      <TermsOfServiceModal open={termsOfServiceOpen} onOpenChange={setTermsOfServiceOpen} />

      <BackToTopButton />
    </div>
  );
};

export default Index;
